module.exports = __webpack_public_path__ + "static/media/fb-create-adaccount-1-es.091cc6a2.png";